import useLenis from "../hooks/useLenis";
import Navbar from "../components/site/Navbar";
import Hero from "../components/site/Hero";
import FunFacts from "../components/site/FunFacts";
import Expertise from "../components/site/Expertise";
import Ecosystem from "../components/site/Ecosystem";
import Clients from "../components/site/Clients";
import Results from "../components/site/Results";
import Insights from "../components/site/Insights";
import ClientReviews from "../components/site/ClientReviews";
import FinalCTA from "../components/site/FinalCTA";
import Footer from "../components/site/Footer";

export default function Home() {
    useLenis();
    return (
        <div data-testid="home-page" className="relative">
            <Navbar />
            <main>
                <Hero />
                <FunFacts />
                <Expertise />
                <Ecosystem />
                <Clients />
                <Results />
                <Insights />
                <ClientReviews />
                <FinalCTA />
            </main>
            <Footer />
        </div>
    );
}
